import { DialogSendMessage } from 'components/dialog-send-message';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from './components/form';
import { FormModel, schema } from './models';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslate } from 'hooks/use-translate';
import React from 'react';

export * from './models';

interface Props {
  initData?: Partial<FormModel>;
  templatesPayload: Record<string, any>;
  onClose: () => void;
  onSubmit: (formData: FormModel) => void;
  isLoading?: boolean;
}
export const DialogSendWhatsApp: React.FC<Props> = ({
  initData,
  onClose,
  onSubmit,
  isLoading = false,
  templatesPayload,
}) => {
  const { t } = useTranslate();

  const methods = useForm({
    defaultValues: schema.cast({ ...initData }, { assert: false, stripUnknown: true }),
    resolver: yupResolver(schema),
  });

  const { handleSubmit } = methods;

  return (
    <DialogSendMessage
      title={t('send-whats-app')}
      DialogProps={{ maxWidth: 'xs' }}
      onClose={onClose}
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormProvider {...methods}>
        <Form isLoading={isLoading} templatesPayload={templatesPayload} />
      </FormProvider>
    </DialogSendMessage>
  );
};
